<template>
  <b-notification :closable="false">
    <span v-html="$t('compCarbonFormsPurchasesHelpCalculatingMethod.text-1')" />
    <br />
    <span v-html="$t('compCarbonFormsPurchasesHelpCalculatingMethod.text-2')" />
    <br />
    <span v-html="$t('compCarbonFormsPurchasesHelpCalculatingMethod.text-3')" />
  </b-notification>
</template>

<script>
export default {
  name: 'HelpCalculatingMethod'
}
</script>
